import React, {  useEffect, useState, useId } from "react";

const LegalNote = ({ setActiveLegalNote, LegalNote, classButton, svg }) => {
  
  const [isLegalVisible, setIsLegalVisible] = useState(false);
  const noteId = useId();
  const modalId = `legal-note-content-${noteId}`;

  useEffect(() => {
    if (!isLegalVisible) return;

    const handleEsc = (e) => {
      if (e.key === "Escape") {
        legalHandleClose();
      }
    };

    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [isLegalVisible, legalHandleClose]);

  function legalHandleOpen() {
    setIsLegalVisible(true);
    if (setActiveLegalNote) {
      setActiveLegalNote('active');
    }
  }

  function legalHandleClose() {
    setIsLegalVisible(false);
    if (setActiveLegalNote) {
      setActiveLegalNote('closed');
    }
  }

  return (
    <div className="legal-notes-wrapper">
      {svg && 
        <button
          className={classButton}
          aria-expanded={isLegalVisible}
          aria-controls={modalId}
          onClick={() => {
            legalHandleOpen();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              legalHandleOpen();
            }
          }}
        > 
         <span aria-hidden="true" dangerouslySetInnerHTML= {
              { __html: svg }
          }></span>
          Nota prawna
        </button>
      }
      {!svg && 
        <button
          className={classButton}
          aria-expanded={isLegalVisible}
          aria-controls={modalId}
          onClick={() => {
            legalHandleOpen();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              legalHandleOpen();
            }
          }}
        > 
          NOTA PRAWNA
        </button>
      }
      <div 
        id={modalId} 
        className={`legal-note ${isLegalVisible ? "open" : ""}`}
        role="dialog"                             
        aria-modal="true"
      >
        <button
          className="close"
          aria-label="Zamknij notę prawną"
          onClick={() => {
            legalHandleClose();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              legalHandleClose();
            }
          }}
        ></button>
        <div
          className="legal-note-body"
          dangerouslySetInnerHTML={{ __html: LegalNote }}
        ></div>
      </div>
    </div>
  );
};

export default LegalNote;